export default __webpack_public_path__ + "static/media/guy1.35cd88da.jpg";